const isApplePlatform = (): boolean => {
  if (typeof navigator === 'undefined') return false
  const platform = navigator.platform ?? ''
  const ua = navigator.userAgent ?? ''
  return /Mac|iPhone|iPad|iPod/i.test(platform) || /Mac OS X/i.test(ua)
}

/** Rótulo visível do atalho Mod+K (sidebar e tooltips). */
export const getModKShortcutLabel = (): string => (isApplePlatform() ? '⌘ K' : 'Ctrl K')

/** Valor para `aria-keyshortcuts` (WAI-ARIA). */
export const getModKAriaKeyshortcuts = (): string =>
  isApplePlatform() ? 'Meta+K' : 'Control+K'
